import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/userBond',
    meta: { title: '客户资金详情' },
    component: Layout,
    redirect: '/userBond/list',
    children: [
      {
        path: 'list',
        meta: { title: '客户资金详情', activeMenu: '/userBond' },
        component: () => import('@/views/userBond/UserBond.vue')
      },
      {
        path: 'detail',
        meta: { title: '客户资金详情', activeMenu: '/userBond' },
        component: () => import('@/views/userBond/UserBondDetail.vue')
      }

    ]
  }

]
